import { styled } from "@mui/material/styles";
import { TableRow } from "@mui/material";

export default styled(TableRow)({
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(142, 195, 242, 0.4)',
  },
  '&:hover': {
    backgroundColor: '#f5f5f5',
  }
});
